export const SOCIAL_MEDIA_PLATFORMS = [
  {
    key: "facebook",
    label: "Facebook",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-6 w-6">
        <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.99 3.66 9.12 8.44 9.88v-6.99h-2.54v-2.89h2.54V9.84c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.45h-1.26c-1.24 0-1.62.77-1.62 1.56v1.87h2.77l-.44 2.89h-2.33v6.99C18.34 21.12 22 16.99 22 12z" />
      </svg>
    ),
  },
  {
    key: "instagram",
    label: "Instagram",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-6 w-6">
        <path d="M7 2C4.24 2 2 4.24 2 7v10c0 2.76 2.24 5 5 5h10c2.76 0 5-2.24 5-5V7c0-2.76-2.24-5-5-5H7zm10 2c1.65 0 3 1.35 3 3v10c0 1.65-1.35 3-3 3H7c-1.65 0-3-1.35-3-3V7c0-1.65 1.35-3 3-3h10zm-5 3a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm4.5-.25a1 1 0 110 2 1 1 0 010-2z" />
      </svg>
    ),
  },
  {
    key: "x",
    label: "X",
    icon: (
      <svg
        fill="currentColor"
        viewBox="0 0 24 24"
        className="h-6 w-6">
        <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z"></path>
      </svg>
    ),
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-6 w-6">
        <path d="M19 0h-14C2.24 0 0 2.24 0 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5zM7.12 20H4.11V9h3.01v11zm-1.51-12.4c-.97 0-1.6-.7-1.6-1.56 0-.89.63-1.56 1.63-1.56s1.6.67 1.62 1.56c0 .86-.63 1.56-1.65 1.56zM20 20h-3v-5.63c0-1.39-.5-2.34-1.75-2.34-.95 0-1.51.64-1.76 1.26-.09.21-.11.5-.11.79V20h-3s.04-9.82 0-11h3v1.56c.4-.63 1.12-1.53 2.72-1.53 1.99 0 3.5 1.3 3.5 4.1V20z" />
      </svg>
    ),
  },
  {
    key: "youtube",
    label: "YouTube",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-6 w-6">
        <path d="M21.8 8.001a2.75 2.75 0 00-1.94-1.94C18.25 6 12 6 12 6s-6.25 0-7.86.061a2.75 2.75 0 00-1.94 1.94A28.25 28.25 0 002 12a28.25 28.25 0 00.2 3.999c.27.94 1 1.67 1.94 1.94C5.75 18 12 18 12 18s6.25 0 7.86-.061a2.75 2.75 0 001.94-1.94A28.25 28.25 0 0022 12a28.25 28.25 0 00-.2-3.999zM10 15V9l5 3-5 3z" />
      </svg>
    ),
  },
];

export const formatFileSize = (bytes) => {
  if (bytes === 0 || isNaN(bytes)) return "0 B";
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / Math.pow(1024, i);
  return `${size.toFixed(1)} ${sizes[i]}`;
};
